module.exports = new __parcel__URL__("Norah.f996d303.svg").toString();